export default __webpack_public_path__ + "static/media/financial.d721aa16.png";